import PyroFragmentElement from './fragment/fragment';
import PyroCollapseElement from './collapse/collapse';
import PyroClockElement from './clock/clockelement';

window.pyrowidgets = {};

// register custom DOM elements
customElements.define(PyroFragmentElement.customTag, PyroFragmentElement);
customElements.define(PyroCollapseElement.customTag, PyroCollapseElement );
customElements.define(PyroClockElement.customTag, PyroClockElement );

console.debug('PyroWidgets successfully loaded.');